import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {
  static targets = [ 'documentId', 'folderId' ];

  connect() {
    let self = this;
    let dragElement = null;
    let authenticityToken = $(this.element).find('input[name=authenticity_token]').val();
    let template = '<li class="upload" draggable="true">' +
      '<i class="icon-ref"></i>' +
      '<div data-dz-name></div>' +
      '<a rel="nofollow" data-remote="true" data-method="delete" class="ui mini compact inverted orange icon button">' +
      '<i class="delete icon"></i>' +
      '</a></li>';

    $(this.element).dropzone({
      clickable: '.upload-handler',
      previewTemplate: template,
      init() {
        this.on('success', (...args) => self.success(...args));
      }
    }).on('click', 'li a[data-remote]', function() {
      $(this).parent().remove();
    });

    $(this.element).on('click', 'li.folder.open', function() {
      $(this).removeClass('open').next('ul').slideUp();
    });

    $(this.element).on('click', 'li.folder:not(.open)', function() {
      $(this).addClass('open').next('ul').slideDown();
    })

    $(this.element).on('drag', 'li:not(.folder)', function(ev) {
      dragElement = $(ev.target);
    }).on('drop', 'li.folder', function(ev) {
      let destination = $(ev.target);
      let dragId = dragElement.data('id');
      $.post(`/l/uploads/${dragId}`, {
        '_method': 'put',
        'authenticity_token': authenticityToken,
        'document_id': self.documentIdTarget.value,
        'upload_folder_id': destination.data('folder-id'),
      }, () => {
        dragElement.appendTo(destination.removeClass('dragover').next('ul'));
      });
    }).on('dragenter', 'li.folder', function() {
      $(this).addClass('dragover');
    }).on('dragleave', 'li.folder', function() {
      $(this).removeClass('dragover');
    });
  }

  success(file, data, progressEvent) {
    let element = $(file.previewElement);
    element.data('id', data.id).find('a').attr(
      'href', `/l/uploads/${data.id}?document_id=${this.documentIdTarget.value}`
    ).on('click', () => element.remove());

    element.find('.icon-ref').addClass(data.icon);

    if($(this.element).has('#upload_folder_id').length == 1) {
      let folder = $(this.element).find(`#upload_folder_${this.folderIdTarget.value}`);
      element.appendTo(folder.next('ul'));

      if(!folder.is('.open')) {
        folder.trigger('click');
      }
    } else {
      element.appendTo($(this.element).children('ul'));
    }
  }
}
